import { render, staticRenderFns } from "./VxCellImageWithTitle.vue?vue&type=template&id=4560ef2a&scoped=true&"
import script from "./VxCellImageWithTitle.vue?vue&type=script&lang=js&"
export * from "./VxCellImageWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./VxCellImageWithTitle.vue?vue&type=style&index=0&id=4560ef2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560ef2a",
  null
  
)

export default component.exports